export default __webpack_public_path__ + "static/media/avatar2.6a2026c5.jpeg";